import Form from '../modules/form';


const SinglePost = {
  init() {
    SinglePost.events();
    new Form('.newsletter__form');
  },

  events() {

  },
};

export default SinglePost;
